import { render, staticRenderFns } from "./AttachmentDisplay.vue?vue&type=template&id=1788448f&scoped=true"
import script from "./AttachmentDisplay.vue?vue&type=script&lang=js"
export * from "./AttachmentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788448f",
  null
  
)

export default component.exports